import { render, staticRenderFns } from "./ColorIdentifier.vue?vue&type=template&id=31f7b1a5&scoped=true&"
import script from "./ColorIdentifier.vue?vue&type=script&lang=js&"
export * from "./ColorIdentifier.vue?vue&type=script&lang=js&"
import style0 from "./ColorIdentifier.vue?vue&type=style&index=0&id=31f7b1a5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f7b1a5",
  null
  
)

export default component.exports